import { TestIdDomain } from 'constants/testIds';

export const EntityAuditHistoryTestIds = {
  ROOT: `${TestIdDomain.ENTITY_AUDIT_HISTORY}.root`,
  HEADER: `${TestIdDomain.ENTITY_AUDIT_HISTORY}.header`,
  HEADER_COUNT: `${TestIdDomain.ENTITY_AUDIT_HISTORY}.header-count`,
  LOADING: `${TestIdDomain.ENTITY_AUDIT_HISTORY}.loading`,
  EMPTY: `${TestIdDomain.ENTITY_AUDIT_HISTORY}.empty`,
  UNAVAILABLE: `${TestIdDomain.ENTITY_AUDIT_HISTORY}.unavailable`,
  ERROR: `${TestIdDomain.ENTITY_AUDIT_HISTORY}.error`,
  RETRY_BUTTON: `${TestIdDomain.ENTITY_AUDIT_HISTORY}.retry-button`,
  SHOWING_NOTE: `${TestIdDomain.ENTITY_AUDIT_HISTORY}.showing-note`,
  LOAD_MORE: `${TestIdDomain.ENTITY_AUDIT_HISTORY}.load-more`,
  END_OF_LIST: `${TestIdDomain.ENTITY_AUDIT_HISTORY}.end-of-list`,
  TABLE: `${TestIdDomain.ENTITY_AUDIT_HISTORY}.table`,
  SHADOWED_TOGGLE: `${TestIdDomain.ENTITY_AUDIT_HISTORY}.shadowed-toggle`,
  ROW_DECORATION: `${TestIdDomain.ENTITY_AUDIT_HISTORY}.row-decoration`,
  ROW_CHIPS: `${TestIdDomain.ENTITY_AUDIT_HISTORY}.row-chips`,
  ROW_NOTE: `${TestIdDomain.ENTITY_AUDIT_HISTORY}.row-note`,
  ROW_ACTIONS: `${TestIdDomain.ENTITY_AUDIT_HISTORY}.row-actions`,
  ROW_TRIGGER: `${TestIdDomain.ENTITY_AUDIT_HISTORY}.row-trigger`,
  ROW_ACTOR: `${TestIdDomain.ENTITY_AUDIT_HISTORY}.row-actor`,
  ROW_ACTOR_SUBLINE: `${TestIdDomain.ENTITY_AUDIT_HISTORY}.row-actor-subline`,
  ROW_FIELDS: `${TestIdDomain.ENTITY_AUDIT_HISTORY}.row-fields`,
  ROW_FIELD: `${TestIdDomain.ENTITY_AUDIT_HISTORY}.row-field`,
  ROW_FIELDS_OVERFLOW: `${TestIdDomain.ENTITY_AUDIT_HISTORY}.row-fields-overflow`,
  DETAIL: `${TestIdDomain.ENTITY_AUDIT_HISTORY}.detail`,
  DETAIL_LOADING: `${TestIdDomain.ENTITY_AUDIT_HISTORY}.detail-loading`,
  DETAIL_UNAVAILABLE: `${TestIdDomain.ENTITY_AUDIT_HISTORY}.detail-unavailable`,
  DETAIL_RETRY_BUTTON: `${TestIdDomain.ENTITY_AUDIT_HISTORY}.detail-retry-button`,
  DETAIL_TABS: `${TestIdDomain.ENTITY_AUDIT_HISTORY}.detail-tabs`,
  DETAIL_HEADER: `${TestIdDomain.ENTITY_AUDIT_HISTORY}.detail-header`,
  DETAIL_ON_BEHALF_OF: `${TestIdDomain.ENTITY_AUDIT_HISTORY}.detail-on-behalf-of`,
  CHANGES_TABLE: `${TestIdDomain.ENTITY_AUDIT_HISTORY}.changes-table`,
  CHANGES_PANEL: `${TestIdDomain.ENTITY_AUDIT_HISTORY}.changes-panel`,
  CHANGES_PANEL_TITLE: `${TestIdDomain.ENTITY_AUDIT_HISTORY}.changes-panel-title`,
  CHANGES_PANEL_SUBTITLE: `${TestIdDomain.ENTITY_AUDIT_HISTORY}.changes-panel-subtitle`,
  CHANGE_FIELD: `${TestIdDomain.ENTITY_AUDIT_HISTORY}.change-field`,
  CHANGE_AUTOMATIC_NOTE: `${TestIdDomain.ENTITY_AUDIT_HISTORY}.change-automatic-note`,
  CHANGE_OLD_VALUE: `${TestIdDomain.ENTITY_AUDIT_HISTORY}.change-old-value`,
  CHANGE_NEW_VALUE: `${TestIdDomain.ENTITY_AUDIT_HISTORY}.change-new-value`,
  CHANGE_SUMMARY: `${TestIdDomain.ENTITY_AUDIT_HISTORY}.change-summary`,
  FIELD_REPLACED: `${TestIdDomain.ENTITY_AUDIT_HISTORY}.field-replaced`,
  RAW_VALUE: `${TestIdDomain.ENTITY_AUDIT_HISTORY}.raw-value`,
  EXPRESSION_TEXT: `${TestIdDomain.ENTITY_AUDIT_HISTORY}.expression-text`,
  NO_CHANGES: `${TestIdDomain.ENTITY_AUDIT_HISTORY}.no-changes`,
  SNAPSHOT_PANEL: `${TestIdDomain.ENTITY_AUDIT_HISTORY}.snapshot-panel`,
  SNAPSHOT_DIFFER_NOTE: `${TestIdDomain.ENTITY_AUDIT_HISTORY}.snapshot-differ-note`,
  SNAPSHOT_COPY_ID: `${TestIdDomain.ENTITY_AUDIT_HISTORY}.snapshot-copy-id`,
  SNAPSHOT_COPY_JSON: `${TestIdDomain.ENTITY_AUDIT_HISTORY}.snapshot-copy-json`,
  SNAPSHOT_BEFORE: `${TestIdDomain.ENTITY_AUDIT_HISTORY}.snapshot-before`,
  SNAPSHOT_AFTER: `${TestIdDomain.ENTITY_AUDIT_HISTORY}.snapshot-after`,
  DETAIL_EXTRA_PANEL: `${TestIdDomain.ENTITY_AUDIT_HISTORY}.detail-extra-panel`,
};
